





















import Vue from "vue";
import AdminService from "@/services/adminService";
import SharedFilesService from "@/services/sharedFilesService";

export default Vue.extend({
  name: "UploadFile",
  props: ["folder_name"],

  data() {
    let tmp: any;
    return {
      file: tmp,
      uploading: false
    };
  },
  methods: {
    handleFileUpload(e) {
      this.file = e.target.files[0]
    },
    async submit(e) {
      this.uploading = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          if(this.$props.folder_name != undefined) {
            formData.append("folder_name", this.$props.folder_name);
          }else{
            formData.append("folder_name", "");
          }
          const sharedFilesService = new SharedFilesService(jwt);
          const response = await sharedFilesService.uploadFile(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.uploading = false;
              alert("Upload Successfully");
              if(this.$props.folder_name != undefined) {
                await this.$router.push("/folders/" + this.$props.folder_name);
              }else{
                await this.$router.push("/sharedfiles");
              }
            }
          }
        } catch (error) {
          this.uploading = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async cancel() {
      if(this.$props.folder_name != undefined) {
        await this.$router.push("/folders/" + this.$props.folder_name);
      }else{
        await this.$router.push("/sharedfiles");
      }
    }
  }
});
